import { useEffect, useRef, useState } from 'react'
import './leaderboard.styles.scss';
import {
  getFilteredDataFromRtDb,
  getLeaderboardChangeDataFromDb,
  getLiveDataFromDb,
  getRegsFromDb,
  getUniqueDocumentFromDb
} from '@/utils/getDataFromDb';
import { useParams } from 'react-router-dom'
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import LeaderboardItem from './leaderboard-item.component';
import { useSelector } from 'react-redux';
import { off } from 'firebase/database';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import Modal, { ModalAlert } from '@/components/modal/modal.component';
import LeaderboardSettings from './leaderboard-settings.component';
import { format } from 'date-fns';
import { version } from '@/changelog-version';
import { getQueryFromFirestore, getQueryFromRtDb, getUniqueDocumentFromFirestore } from '@/utils/getDataFromDbSimplified';

const LeaderboardPage = ({
  playerView,
  playerData,
  playerList,
  playerGameData
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const { livePath } = useParams();
  const [liveData, setLiveData] = useState(null);
  const [leaderData, setLeaderData] = useState(null);
  const [teamList, setTeamList] = useState({});
  const [teamMembers, setTeamMembers] = useState(null);
  const [levels, setLevels] = useState(null);
  const [gameData, setGameData] = useState(null);
  const [dataToDisplay, setDataToDisplay] = useState({});
  const [adminAccess, setAdminAccess] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [displayCount, setDisplayCount] = useState(0);
  const [alertMessage, setAlertMessage] = useState(false);
  const levelRef = useRef();
  const leaderRef = useRef({});
  let liveListenerRef = useRef();
  let gameListenerRef = useRef();
  let leaderboardListenerRef = useRef();
  let teamLeaderboardListenerRef = useRef();
  let levelListenerRef = useRef();
  let changeListenerRef = useRef();
  let regsListenerRef = useRef();

  useEffect(() => {
    if (!livePath) return;
    console.log(livePath);

    if (livePath === 'primary' && playerList && playerGameData) {
      getPrimaryLeaderboard();
      setGameData({ ...playerGameData });
      return;
    }

    function getLiveData() {
      // console.log('getting live data')
      getLiveDataFromDb({
        'path': livePath,
        'callback': callback,
        'handleListener': handleListener
      })
      function callback(data) {
        if (data.status !== 'active') {
          setAlertMessage('This leaderboard is not active.');
          return;
        }
        setLiveData(data);
        changeDocumentTitle(`Gamably | ${data.name}`, gameData?.icon);
        // console.log(data);
        setDisplayCount(data.count);
        // if (data.badges) {
        //     getBadges(data.gameId);
        // }
      }
      function handleListener(unsub) {
        liveListenerRef.current = unsub;
      }
    }

    getLiveData();

    return () => {
      if (liveListenerRef.current) liveListenerRef.current();
      liveListenerRef.current = null;

    }
  }, [livePath, playerList, playerGameData])

  useEffect(() => {
    if (!liveData) return;
    leaderRef.current = {};
    levelRef.current = {};
    
    if (liveData.levels && liveData.levels === true) {
      // console.log(liveData.levels);
      getLevels(liveData.gameId);
    }

    

    function getLevels(gameId) {
      getFilteredDataFromRtDb({
        'path': `games/${gameId}/gameElementShortList`,
        'key': 'type',
        'value': 'level',
        'callback': callback,
        'handleListener': handleListener
      })
      function callback(data) {
        levelRef.current = { ...levelRef.current, ...{ [data.id]: data } }
        setLevels(levelRef.current);
      }
      function handleListener(unsub) {
        levelListenerRef.current = unsub;
      }
    }

    function getLeaderboardData(leaderboardSettings) {
      if (leaderboardSettings.indOrTeams === 'individuals') {
        getQueryFromFirestore({
          'path': `games/${leaderboardSettings.gameId}/players`,
          'queryArray': [
            {
              'field': 'status',
              'operator': '==',
              'value': 'active'
            },
            {
              'field': 'enroll_method',
              'operator': 'in',
              'value': ['email', 'upload']
            },
          ],
          'orderBy': {
            'field': leaderboardSettings.data,
            'direction': 'desc'
          },
          'limit': leaderboardSettings.count ?? 20,
          'callback': callback,
          'handleListener': handleListener
        })
        function callback(data) {
          leaderRef.current = {
            ...leaderRef.current,
            ...{ [data.playerId]: data }
          };
          setLeaderData({ ...leaderRef.current });
        }
        function handleListener(unsub) {
          leaderboardListenerRef.current = unsub;
        }
      } else {
        getQueryFromRtDb({
          'path': `games/${leaderboardSettings.gameId}/leaderList`,
          'callback': teamCallback,
          'handleListener': handleTeamListener
        })
        getTeamList(leaderboardSettings.gameId);
        getTeamMembers(leaderboardSettings.gameId);
        function teamCallback(data) {
          leaderRef.current = {
            ...leaderRef.current,
            ...data
          };
          setLeaderData({ ...leaderRef.current });
        }
        function handleTeamListener(unsub) {
          teamLeaderboardListenerRef.current = unsub;
        }
      }
    }

    function getGameData(gameId, leaderboardName) {
      getUniqueDocumentFromDb({
        'collection': 'games',
        'docId': gameId,
        'callback': callback,
        'handleListener': handleListener,
      })
      function callback(data) {
        setGameData(data);
        changeDocumentTitle(`Gamably | ${leaderboardName}`, data.icon);
      }
      function handleListener(unsub) {
        gameListenerRef.current = unsub;
      }
    }

    getLeaderboardData(liveData);
    getGameData(liveData.gameId, liveData.name);

    return () => {
      if (levelListenerRef.current) {
        off(levelListenerRef.current);
        levelListenerRef.current = null;
      }
      if (leaderboardListenerRef.current) {
        leaderboardListenerRef.current();
        leaderboardListenerRef.current = null;
      }
      if (teamLeaderboardListenerRef.current) {
        off(teamLeaderboardListenerRef.current);
        teamLeaderboardListenerRef.current = null;
      }
      if (gameListenerRef.current) {
        gameListenerRef.current();
        gameListenerRef.current = null;
      }
    }
  }, [liveData])

  useEffect(() => {
    if (!liveData || !userProfile) return;
    function checkAdminAccess() {
      if (!userProfile) return;
      getRegsFromDb({
        'gameId': liveData.gameId,
        'callback': callback,
        'handleListener': handleListener
      })
      function callback(data) {
        if (
          data.roles[userProfile.appId] &&
          (
            data.roles[userProfile.appId].includes('owner') ||
            data.roles[userProfile.appId].includes('manager')
          )
        ) {
          setAdminAccess(true);
        }
      }
      function handleListener(unsub) {
        regsListenerRef.current = unsub;
      }
    }
    checkAdminAccess();

    return () => {
      if (regsListenerRef.current) regsListenerRef.current();
      regsListenerRef.current = null;
    }
  }, [liveData?.gameId, userProfile?.appId])

  useEffect(() => {
    if (!leaderData || !liveData) return;

    

    function getChangeData() {
      // console.log('getting change data')
      getLeaderboardChangeDataFromDb({
        'gameId': liveData.gameId,
        'leaderboardId': liveData.id,
        'callback': callback,
        'handleListener': handleListener,
      })

      function callback(changeData) {
        compileLeaderData(changeData);
      }
      function handleListener(unsub) {
        changeListenerRef.current = unsub;
      }
    }

    if (liveData.data === 'change') {
      getChangeData();
    } else {
      compileLeaderData();
    }

    return () => {
      if (changeListenerRef.current) off(changeListenerRef.current);
      changeListenerRef.current = null;
    }
  }, [leaderData, liveData, teamMembers, teamList])


  function compileLeaderData(changeData) {
    let leaderObj = {};
    if (liveData.indOrTeams === 'individuals') {
      const leaderArr = Object.values(leaderRef.current).filter(l => l.status === 'active' && !l.team);
      for (let l of leaderArr) {
        let obj = {
          'playerId': l.playerId,
          'name':
            liveData.nameDisplay === 'full'
              ? `${l.fName} ${l.lName}`
              : liveData.nameDisplay === 'display'
                ? l.displayName
                : l.secretName,
          'icon': l.icon,
          'gradient': l.gradient,
          'badges': l.badges,
          'dataValue': l[liveData.data] ?? 0,
        }
        leaderObj[obj.playerId] = obj;
      }
    } else if (liveData.indOrTeams === 'teams') {
      const teamArr = Object.values(teamList);
      for (let t of teamArr) {
        let tempData = 0;
        if (teamMembers) {
          const members = teamMembers[t.playerId]?.members ?? [];
          // console.log(members);
          for (let m of members) {
            const playerData = leaderRef.current[m];
            if (!playerData) continue;
            tempData += playerData[liveData.data] ?? 0;
            t.animate = playerData.animate ? true : false;
          }
        }
        let obj = {
          'playerId': t.playerId,
          'name': t.displayName,
          'icon': t.icon,
          'gradient': t.gradient,
          'badges': t.badges,
          'dataValue': tempData,
        }
        leaderObj[obj.playerId] = obj;
      }
    }
    for (let l of Object.values(leaderObj)) {
      const newObj = { ...l };
      if (changeData) {
        if (changeData[l.playerId]) {
          let playerChange = changeData[l.playerId];
          let baseline = 0;
          let newData = 0;
          let change = 0;
          let pct = 0;
          if (playerChange.baseline) {
            baseline = playerChange.baseline;
          }
          if (playerChange.newData) {
            newData = playerChange.newData;
          } else {
            newData = baseline;
          }
          change = newData - baseline;
          pct = 0;
          if (baseline !== 0 && change !== 0) {
            pct = (change / baseline) * 100
          }
          if (liveData.opt_changeDisplay === 'actual') {
            newObj.data = change;
          } else {
            newObj.data = pct;
            newObj.actual = change;
          }
        } else {
          newObj.data = 0;
          newObj.actual = 0;
        }
      } else {
        newObj.data = l.dataValue ?? 0;
      }

      if (
        dataToDisplay[newObj.playerId] &&
        dataToDisplay[newObj.playerId].data !== newObj.data
      ) {
        newObj.animate = true;
      }
      leaderObj[newObj.playerId] = newObj
    }
    setDataToDisplay({ ...leaderObj });
  }

  function getPrimaryLeaderboard() {
    const primLiveData = {
      count: 20,
      data: "points",
      desc: "Primary Leaderboard",
      icon: "/images/icons/leaderboard.png",
      gameId: playerGameData.gameId,
      id: "primary_leaderboard",
      indOrTeams: "individuals",
      name: "Primary Leaderboard",
      nameDisplay: "display",
      totals: true,
      ts: 1772691855258,
      ts_created: 1772691651616,
      type: "leaderboard"
    };
    setLiveData(primLiveData);
    setDisplayCount(primLiveData.count);
    console.log(playerList);
    setLeaderData({ ...playerList });
  }

  function getTeamList(gameId) {
    getQueryFromFirestore({
      'path': `games/${gameId}/players`,
      'queryArray': [
        {
          'field': 'status',
          'operator': '==',
          'value': 'active'
        },
        {
          'field': 'team',
          'operator': '==',
          'value': true
        }
      ],
      'once': true,
      'callback': callback,
    })
    function callback(data) {
      // console.log(data);
      setTeamList(data);
    }
  }

  function getTeamMembers(gameId) {
    getUniqueDocumentFromFirestore({
      'path': `games/${gameId}/teamMembers/${gameId}-teamMembers`,
      'callback': callback,
      'once': true,
    })
    function callback(data) {
      // console.log(data);
      setTeamMembers(data);
    }
  }

  function showFullLeaderboard() {
    // console.log('full')
    setDisplayCount(Object.values(dataToDisplay).length);
    setAlertMessage('Full Leaderboard is now displayed.');
  }

  return (
    <div className='leaderboard-page-container'>
      {
        (gameData)
          ?
          <div className={`leaderboard-page-content ${screenSize}`} style={
            (gameData.bg.type === 'gradient')
              ?
              { 'background': `linear-gradient(to bottom, ${gameData.bg.hexTop}, ${gameData.bg.hexBottom})` }
              :
              { 'backgroundImage': `url("${gameData.bg.url}")` }
          }>
            {
              (adminAccess) &&
              <div className='menu-button'>
                <button
                  className={`g-button ${screenSize === 'mobile' || screenSize === 'tablet' ? 'small-btn' : 'med-btn'}`}
                  onClick={() => setShowSettingsModal(true)}>
                  <FontAwesomeIcon
                    icon={faGear}
                    size="xl" />
                </button>
              </div>
            }
            <div className='leaderboard-header content'>
              <div className='leaderboard-head-image'>
                <ImageContainer src={gameData.header} alt='game primary icon' />
              </div>
              {
                (liveData) &&
                <div className='leaderboard-head-title'>
                  {liveData.name}
                </div>
              }
            </div>
            {/* <div className="g-space-0-5"></div> */}
            {
              (liveData && liveData.data === 'change') &&
              <div>
                {
                  (liveData.opt_baselineSetDate)
                    ? <div className='meta'>Baseline set {format(new Date(liveData.opt_baselineSetDate), "Pp")}</div>
                    : <div className='meta'>No baseline has been set to measure change.</div>
                }
                {
                  (liveData.opt_dateEnd)
                    ? <div className='meta'>Will stop tracking on {format(new Date(liveData.opt_dateEnd), "Pp")}</div>
                    : null
                }
              </div>
            }
            <div className='g-space-0-5'></div>
            {
              (Object.values(dataToDisplay).length > 0 && liveData)
                ?
                <div className='leaderboard-content content'>
                  {
                    Object.values(dataToDisplay)
                      .sort((a, b) =>
                        b.data !== a.data
                          ? b.data - a.data
                          : (a.name ?? '').toLowerCase() > (b.name ?? '').toLowerCase() ? 1 : -1
                      )
                      .map((l, index) => {
                        if (l.data < 0) console.log(l.data);
                        if (Number(index) + 1 > displayCount) return;
                        return (
                          <div key={l.playerId}>
                            <LeaderboardItem
                              leader={l}
                              index={index}
                              liveData={liveData}
                              levels={levels}
                              playerView={playerView} />
                          </div>
                        )
                      })
                  }
                  {
                    (
                      playerView &&
                      playerData &&
                      displayCount &&
                      dataToDisplay[playerData.playerId] &&
                      Object.keys(dataToDisplay).length > displayCount &&
                      Object.values(dataToDisplay)
                        .sort((a, b) =>
                          b.data !== a.data
                            ? b.data - a.data
                            : (a.name ?? '').toLowerCase() > (b.name ?? '').toLowerCase() ? 1 : -1
                        )
                        .findIndex(l => l.playerId === playerData.playerId) >= displayCount
                    ) &&
                    <>
                      <h2>...</h2>
                      <LeaderboardItem
                        leader={dataToDisplay[playerData.playerId]}
                        index={Object.values(dataToDisplay)
                          .sort((a, b) =>
                            b.data !== a.data
                              ? b.data - a.data
                              : (a.name ?? '').toLowerCase() > (b.name ?? '').toLowerCase() ? 1 : -1
                          )
                          .findIndex(l => l.playerId === playerData.playerId)}
                        liveData={liveData}
                        levels={levels}
                        playerView={playerView} />
                    </>
                  }
                  <div className='meta center-col'>{version}</div>
                </div>
                :
                <div className='center'><h3>Loading Players...</h3></div>
            }
          </div>
          :
          <div className='center'><h1>Loading Game Data...</h1></div>
      }
      <Modal
        show={showSettingsModal}
        cancel={() => setShowSettingsModal(false)}
        closeButton={true}
        text='Leaderboard Settings' >
        {
          (liveData) &&
          <div>
            <LeaderboardSettings
              liveData={liveData}
              leaderData={dataToDisplay}
              showFullLeaderboard={showFullLeaderboard} />
            <hr />
            <div className='buttons'>
              <button
                className='g-button'
                onClick={() => setShowSettingsModal(false)}>
                Done
              </button>
            </div>
          </div>
        }
      </Modal>
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
    </div>
  )
}

export default LeaderboardPage